import { useParams } from "react-router-dom";
import PostApiCall from "../AdminPannel/Api/PostApi";
import moment from "moment";
import Notiflix from "notiflix";
import React, { useEffect, useState } from "react";
import "./SakalVisitorRegistration.css";
import { Select, Radio, Checkbox, Row, Col } from "antd";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
export default function VisitorRegistrationFormSakal() {
  const [mailtype, setType] = useState("");
  const [clientid, setClientId] = useState("");
  const mailtypefetchurl = useParams();
  const { Option } = Select;
  const [visitorId, setVisitorId] = useState(null);
  const [name, setName] = useState("");
  const [mobile, setMobile] = useState("");
  const [email, setEmail] = useState("");
  const [otherCity, setOtherCity] = useState("");
  const [msg, setMsg] = useState("");
  const [propertyType, setPropertyType] = useState([]);

  // const [residential, setResidential] = useState(false);
  // const [propertyCity, setPropertyCity] = useState("");
  // // const [budget, setBudget] = useState(null);
  const [investmentType, setInvestmentType] = useState(null);

  const [eventName, setEventName] = useState("");

  const [villa, setVilla] = useState(false);
  const [plots, setPlots] = useState(false);
  const [commercial, setCommercial] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const numberRegex = /^[0-9]*$/;
  // const numberRegex =
  //   /^\+?(\d{1,3})?[\s\-]*\(?\d{1,4}\)?[\s\-]*\d{1,4}[\s\-]*\d{1,4}$/;

  const [VisitingDate, setVisitingDate] = useState("");
  const [VisitingDateValue, setVisitingDateValue] = useState([
    { Key: 1, Value: "01-06-2024" },
    { Key: 2, Value: "02-06-2024" },
  ]);
  // **** Number of person visiting ****
  const [VisitingPerson, setVisitingPerson] = useState("");
  const [visitDate, setVisitDate] = useState("");
  const [location, setLocation] = useState([]);
  const [residance, setResidence] = useState("");
  const [VisitingPersonValue, setVisitingPersonValue] = useState([
    { Key: 1, Value: "One" },
    { Key: 2, Value: "Two" },
    { Key: 3, Value: "Three" },
    { Key: 4, Value: "Four" },
    { Key: 5, Value: "Five" },
    { Key: 6, Value: "Six" },
    { Key: 7, Value: "Seven" },
    { Key: 8, Value: "Eight" },
    { Key: 9, Value: "Nine" },
    { Key: 10, Value: "Ten" },
  ]);

  const onChangeResidant = (e) => {
    setResidence(e.target.value);
  };
  const onChangeInvestmentType = (e) => {
    setInvestmentType(e.join(", "));
  };

  const isEmailValid = (email) => {
    return emailRegex.test(email);
  };

  const isPhoneValid = (phone) => {
    return numberRegex.test(phone);
  };

  const handleValidateForm = () => {
    if (name == "") {
      Notiflix.Notify.failure("Name is required. Please enter your name.");
      return;
    }
    if (!mobile || mobile == "") {
      Notiflix.Notify.failure(
        "Mobile number is required. Please enter your mobile number.",
      );
      return;
    }
    //  else if (!isPhoneValid(mobile)) {
    //   Notiflix.Notify.failure("Invalid Mobile Number");
    //   return;
    // }
    if (email == "") {
      Notiflix.Notify.failure("Email is required. Please enter your Email.");
      return;
    } else if (!isEmailValid(email)) {
      Notiflix.Notify.failure("Invalid email. Please enter a valid email.");
      return;
    }
    if (visitDate == "") {
      Notiflix.Notify.failure("Please select visiting date.");
      return;
    }
    if (location == "" || location?.length < 1) {
      Notiflix.Notify.failure("Please select preferred location.");
      return;
    }
    if (location == "Other" && !otherCity) {
      Notiflix.Notify.failure("Please enter the other city.");
      return;
    }
    // if (residance == "") {
    //   Notiflix.Notify.failure("Please choose property purchase eligibility.");
    //   return;
    // }
    // if (!investmentType) {
    //   Notiflix.Notify.failure("Please select investment type.");
    //   return;
    // }

    handleSubmitForm();
  };

  const handleSubmitForm = () => {
    Notiflix.Loading.dots("Please Wait...");
    PostApiCall.postRequest(
      {
        // visitorid: visitorId,
        // mailtype: mailtype,
        // mail: "html",
        // clientid: clientid,
        visitorname: name,
        email: email,
        mobile: mobile,
        selectedCity: location !== "Other" ? location?.join(", ") : otherCity,
        // message: msg,
        // residentials: residential,
        // plots: plots,
        // villa: villa,
        // commercial: commercial,
        DayofAttending: visitDate,
        natioanlity: residance,
        // person: VisitingPerson,
        // eventname: "Abu Dhabi",
        // prefferedbudget: budget ? budget : null,
        investmenttype: investmentType,
        website: "https://sakalglobalrealtyexpo.com/",
      },
      "UpdateVisitorRegistrationSakal",
    ).then((result) =>
      result.json().then((obj) => {
        if (result.status == 200 || result.status == 201) {
          Notiflix.Loading.remove();
          Notiflix.Notify.success("Form Submitted Succesfully");
          window.parent.location.href =
            "https://sakalglobalrealtyexpo.com/thankyou.html";
          setName("");
          setEmail("");
          setMobile("");
          setLocation([]);
          // setTimeout(() => {
          //   window.location.reload();
          // }, 3000);
        }
      }),
    );
  };

  // notiflix message position
  useEffect(() => {
    Notiflix.Notify.init({
      width: "280px",
      position: "center-bottom",
      distance: "10px",
      opacity: 1,
      clickToClose: true,
      showOnlyTheLastOne: true,
      //   useFontAwesome: true,
      fontSize: "15px",
      timeout: 4000,
    });
  }, []);
  useEffect(() => {
    setType(mailtypefetchurl.mailtype);
    setClientId(mailtypefetchurl.clientid);
  }, []);

  return (
    <>
      <div className="p-3 w-100 visitorformbg">
        <div className="main-heading-sakal main-heading-left-sakal">
          <h2>Kindly Register Below - Free Visitor Registration!</h2>
          <p>
            <strong>Free Entry-</strong> Snacks & High Tea provided to all
            Registered Clients
          </p>
        </div>
        <div className="row">
          <div className="col-12 col-sm-6 mb-2">
            <label>Name *</label>
            <input
              type="text"
              className="form-control visitor-input py-3"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6 mb-2 phone-number-input">
            <label>Mobile Number *</label>
            {/* <input
			  type="text"
			  className="form-control visitor-input"
			  value={mobile}
			  onChange={(e) => setMobile(e.target.value)}
			/> */}
            <PhoneInput
              defaultCountry="AE"
              countries={["IN", "AE"]}
              placeholder="Enter phone number"
              value={mobile}
              onChange={setMobile}
            />
          </div>
          <div className="col-12 col-sm-6 mb-2">
            <label>Email *</label>
            <input
              type="email"
              className="form-control visitor-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="col-12 col-sm-6 mb-2">
            <label>Date of Visit *</label>
            <Select
              showSearch
              className="visitor-input form-control"
              placeholder="Date of Visit"
              optionFilterProp="children"
              onChange={(value) => setVisitDate(value)}
              // filterOption={(input, option) =>
              // option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              // }
            >
              <Option value="28th November">28th November</Option>
              <Option value="29th November">29th November</Option>
            </Select>
          </div>
          <div className="col-12 col-sm-3 mb-2">
            <label>Type of Property *</label>
            <Select
              showSearch
              mode="multiple"
              className="visitor-input form-control"
              placeholder="Choose type of property"
              optionFilterProp="children"
              onChange={(value) => setInvestmentType(value)}
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }>
              <Option value="Residential">Residential</Option>
              <Option value="Commercial">Commercial</Option>
              <Option value="Plot">Plot</Option>
              <Option value="Villa">Villa</Option>
            </Select>
          </div>
          <div className="col-12 col-sm-6 mb-2">
            <label>Preferred Location *</label>
            <Select
              showSearch
              mode={location === "Other" ? undefined : "multiple"}
              className="visitor-input form-control"
              placeholder="Preferred Location"
              filterOption={(input, option) =>
                option.props.children
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
              onChange={(value) => {
                if (value.includes && value.includes("Other")) {
                  setLocation("Other");
                } else {
                  setLocation(value);
                  setOtherCity("");
                }
              }}>
              <Option value="Pune">Pune</Option>
              <Option value="West Pune">West Pune</Option>
              <Option value="East Pune">East Pune</Option>
              <Option value="North-West Pune">North-West Pune</Option>
              <Option value="Central Pune">Central Pune</Option>
              <Option value="Mumbai">Mumbai</Option>
              <Option value="Shivajinagar">Shivajinagar</Option>
              <Option value="Deccan Gymkhana">Deccan Gymkhana</Option>
              <Option value="Model Colony">Model Colony</Option>
              <Option value="Camp">Camp</Option>
              <Option value="Erandwane">Erandwane</Option>
              <Option value="Swargate">Swargate</Option>
              <Option value="Balewadi">Balewadi</Option>
              <Option value="Baner">Baner</Option>
              <Option value="Bavdhan">Bavdhan</Option>
              <Option value="Hadapsar">Hadapsar</Option>
              <Option value="Hinjewadi">Hinjewadi</Option>
              <Option value="Kharadi">Kharadi</Option>
              <Option value="Kothrud">Kothrud</Option>
              <Option value="Magarpatta City">Magarpatta City</Option>
              <Option value="Mamurdi">Mamurdi</Option>
              <Option value="Mundhwa">Mundhwa</Option>
              <Option value="Pimple Nilakh">Pimple Nilakh</Option>
              <Option value="Pimple Saudagar">Pimple Saudagar</Option>
              <Option value="Punawale">Punawale</Option>
              <Option value="Ravet">Ravet</Option>
              <Option value="Talegaon Dabhade">Talegaon Dabhade</Option>
              <Option value="Wadgaon Sheri">Wadgaon Sheri</Option>
              <Option value="Wagholi">Wagholi</Option>
              <Option value="Wakad">Wakad</Option>
              <Option value="Lonavala">Lonavala</Option>
              <Option value="Khandala">Khandala</Option>
              <Option value="Karjat">Karjat</Option>
              {/* <Option value="Mumbai">Mumbai</Option>
              <Option value="Pune">Pune</Option>
              <Option value="Kolhapur">Kolhapur</Option>
              <Option value="Lonavala">Lonavala</Option>
              <Option value="Thane">Thane</Option>
              <Option value="Nagpur">Nagpur</Option>
              <Option value="Aurangabad">Aurangabad</Option>
              <Option value="Hyderabad">Hyderabad</Option>
              <Option value="Bangalore">Bangalore</Option>
              <Option value="Chennai">Chennai</Option>
              <Option value="Delhi NCR">Delhi NCR</Option>
              <Option value="Gurugram">Gurugram</Option>
              <Option value="Kolkata">Kolkata</Option>
              <Option value="Goa">Goa</Option> */}
              <Option value="Other">Other</Option>
            </Select>
          </div>
          {location === "Other" && (
            <div className="col-12 col-sm-6 mb-2">
              <label>Other City *</label>
              <input
                type="text"
                className="form-control visitor-input py-3"
                value={otherCity}
                onChange={(e) => setOtherCity(e.target.value)}
              />
            </div>
          )}

          {/* <div className="col-12 col-sm-6 mb-2">
						<div className="mb-2">
							Preferred Budget
						</div>
						<input
							type="text"
							className="form-control visitor-input py-3"
							value={budget}
							onChange={(e) => {
								setBudget(e.target.value)
							}
							}
						/>
					</div> */}
          <small>
            *Note that only Indians, Non Resident Indians (NRI's), People of
            Indian Origin (PIO's), Overseas Citizen of India (OCI's) & Resident
            Indians living in India or Abroad are Allowed to buy properties in
            India.
          </small>
          <div className="mt-1 mb-0 mb-sm-1 pb-3 pb-sm-2 col-sm-6 align-self-sm-end">
            <button
              type="button"
              className="visitor-btn visitor-btn1 text-white"
              onClick={() => handleValidateForm()}>
              Register as a Visitor
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
